import Imagen from "./Imagen";

class Habitacion {

    idModal: string;

    titulo: string;

    descripcion: string[];

    tituloTarifa: string | undefined;

    descricionTarifa: string[] | undefined;

    icono: string;

    imagenes: Imagen[];

    constructor(idModal:string, titulo: string, descripcion: string[], icono: string, imagenes: Imagen[], tituloTarifa?: string, descricionTarifa?: string[]) {
      this.idModal = idModal;
      this.titulo = titulo;
      this.descripcion = descripcion;
      this.icono = icono;
      this.imagenes = imagenes;
      this.tituloTarifa = tituloTarifa;
      this.descricionTarifa = descricionTarifa;
    }

}

export default Habitacion;